(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["option-value"] && !Shopify.designMode) return;
  try {
    const buyButton = document.querySelector('.buy-buttons button');
const variantInputs = document.querySelectorAll('.variant-picker input');
let url = window.location.pathname;
if( url=="/products/gift-card"){
  buyButton.textContent = "Select Denominations";
}else{
  buyButton.textContent = "Select Size";
}

variantInputs.forEach(input => {
  input.replaceWith(input.cloneNode(true));
});
document.querySelectorAll('.variant-picker input:checked').forEach(input => input.checked = false);

document.addEventListener('change', function(e) {
  if (e.target.closest('.variant-picker input')) {
    const anySelected = document.querySelector('.variant-picker input:checked');
    if (anySelected) {
      buyButton.textContent = "Add to Cart";
      console.log("Add to Cart")
    } else if ( url=="/products/gift-card") {
      buyButton.textContent = "Select Denominations";
      console.log("gift-card")
    } else{
      console.log("Select Size")
        buyButton.textContent = "Select Size";
    }
  }
});

buyButton.addEventListener('click', function(e) {
  const anySelected = document.querySelector('.variant-picker input:checked');
  if (!anySelected) {
    e.preventDefault();
    document.querySelector('.cart_error').style.display = 'block';
   if( url=="/products/gift-card"){
  buyButton.textContent = "Select Denominations";
}else{
  buyButton.textContent = "Select Size";
}

    document.getElementById('select_size').scrollIntoView({ behavior: 'smooth', block: 'center' });

    return false;
  }
  document.querySelector('.cart_error').style.display = 'none';
});
  } catch(e) { console.error(e); }
})();

})();
